export default __webpack_public_path__ + "static/pragicts-digital-outreach-verticals-it-e846f19692085f50c334f7870e5c9d1d.jpg";